
// SwarLive Theme JS
document.addEventListener('DOMContentLoaded', function() {

  // Mobile nav
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-close');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => mobileNav.classList.add('open'));
    if (mobileClose) mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'));
    mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', () => mobileNav.classList.remove('open')));
  }

  // Occasion tags
  document.querySelectorAll('.occ-tag').forEach(tag => {
    tag.addEventListener('click', () => {
      document.querySelectorAll('.occ-tag').forEach(t => t.classList.remove('active'));
      tag.classList.add('active');
    });
  });

  // Qty controls
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-control').querySelector('.qty-input');
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'plus') val = Math.min(val + 1, 99);
      if (btn.dataset.action === 'minus') val = Math.max(val - 1, 1);
      input.value = val;
    });
  });

  // Product image gallery
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const main = thumb.closest('.product-gallery').querySelector('.product-gallery__main img');
      if (main && thumb.querySelector('img')) main.src = thumb.querySelector('img').src;
    });
  });

  // Toast helper
  window.showToast = function(msg) {
    let toast = document.querySelector('.toast');
    if (!toast) { toast = document.createElement('div'); toast.className = 'toast'; document.body.appendChild(toast); }
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3000);
  };

  // Cart remove animation
  document.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', function() {
      const item = this.closest('.cart-item');
      if (item) { item.style.opacity = '0'; item.style.transform = 'translateX(20px)'; item.style.transition = 'all 0.3s ease'; setTimeout(() => item.remove(), 300); }
    });
  });

  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  // Add to cart button state
  document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const orig = this.textContent;
      this.textContent = '✓ Added to Cart';
      this.style.background = 'var(--teal)';
      setTimeout(() => { this.textContent = orig; this.style.background = ''; }, 2000);
      showToast('Added to your cart!');
    });
  });

});
